import { SEO, SchemaMarkup } from '../components/seo';
import { openCookieBanner } from '../lib/consent';

export function Privacyverklaring() {
  return (
    <>
      <SEO
        title="Privacyverklaring | PuntUit"
        description="Privacyverklaring van Bureau PuntUit B.V. — welke persoonsgegevens we verwerken via puntuit.nl, waarom, en welke rechten je hebt."
        canonicalUrl="/privacyverklaring"
      />
      <SchemaMarkup
        type="webpage"
        pageUrl="https://puntuit.nl/privacyverklaring"
        pageTitle="Privacyverklaring — PuntUit"
        breadcrumb={[
          { name: 'Home', url: '/' },
          { name: 'Privacyverklaring', url: '/privacyverklaring' },
        ]}
      />
      <div className="pt-28">
        <section className="bg-[#0284c7] text-white">
          <div className="container py-24 md:py-32 max-w-4xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Privacyverklaring</h1>
            <p className="text-xl text-primary-100">Bureau PuntUit B.V. — laatst bijgewerkt: juli 2026</p>
          </div>
        </section>

        <section className="section-padding bg-white">
          <div className="container max-w-4xl">
            <article className="prose prose-gray max-w-none space-y-12 text-gray-700 leading-relaxed">

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Wie zijn wij</h2>
                <p>
                  Deze privacyverklaring gaat over de website puntuit.nl van Bureau PuntUit B.V.,
                  ingeschreven bij de Kamer van Koophandel onder nummer 87786516. Je bereikt ons via
                  info@puntuit.nl of 085 – 107 12 56. Ons bezoekadres is Stammerhove 3, 1112 VA Diemen;
                  ons postadres is Vleerstraat 78, 2513 VJ Den Haag.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Welke gegevens we verwerken en waarom</h2>
                <div className="space-y-4">
                  <p>Via deze website verwerken we alleen de gegevens die je zelf aan ons geeft:</p>
                  <ul className="list-disc pl-6 space-y-3">
                    <li>
                      <strong>Contactformulier:</strong> je naam, e-mailadres, telefoonnummer (optioneel)
                      en je vraag of situatie. We gebruiken deze gegevens om je vraag te beantwoorden en
                      contact met je op te nemen.
                    </li>
                    <li>
                      <strong>Brochure-download:</strong> je naam, e-mailadres en eventueel de naam van je
                      organisatie. We gebruiken deze gegevens om je aanvraag op te volgen.
                    </li>
                    <li>
                      <strong>Kennismakingsgesprek plannen:</strong> plan je via de agenda op onze
                      contactpagina een gesprek in, dan verwerkt onze planningstool Calendly je naam,
                      e-mailadres en het gekozen moment. Zie ook de privacyverklaring van Calendly.
                    </li>
                    <li>
                      <strong>Direct contact:</strong> gegevens die je deelt als je ons belt, mailt of
                      appt, gebruiken we alleen om je te woord te staan.
                    </li>
                  </ul>
                  <p>
                    De grondslag voor deze verwerkingen is de uitvoering van (de voorbereiding op) een
                    overeenkomst of ons gerechtvaardigd belang om vragen van (potentiële) klanten te
                    beantwoorden. De formulieren op deze site worden technisch verstuurd via de dienst
                    FormSubmit en per e-mail bij ons bezorgd.
                  </p>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Gesprekken met de vertrouwenspersoon</h2>
                <p>
                  Wat medewerkers met een vertrouwenspersoon van PuntUit bespreken is vertrouwelijk en
                  verloopt niet via deze website, maar via het beveiligde platform praatuit.nl. Werkgevers
                  ontvangen daarover uitsluitend geanonimiseerde rapportages die niet tot personen te
                  herleiden zijn.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Cookies</h2>
                <div className="space-y-4">
                  <p>
                    We gebruiken functionele cookies die nodig zijn om de website goed te laten werken.
                    Marketingcookies plaatsen we alleen nadat je daar via de cookiebanner toestemming
                    voor hebt gegeven. Het gaat dan om Google Tag Manager, Google Ads en Microsoft
                    Clarity, waarmee we meten hoe onze campagnes presteren en hoe de website wordt
                    gebruikt. Weiger je, dan worden deze diensten niet geladen.
                  </p>
                  <p>
                    Je kunt je keuze op elk moment aanpassen via{' '}
                    <button
                      type="button"
                      onClick={openCookieBanner}
                      className="underline underline-offset-2 decoration-primary-300 hover:decoration-primary-600 text-[#0284c7]"
                    >
                      cookie-instellingen
                    </button>
                    {' '}(ook te vinden onderaan elke pagina).
                  </p>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Met wie we gegevens delen</h2>
                <p>
                  We verkopen je gegevens nooit. We delen ze alleen met dienstverleners die ons helpen
                  deze website te laten draaien en aanvragen af te handelen, zoals onze hostingpartij,
                  FormSubmit (formulieren), Calendly (afspraken) en — alleen na jouw toestemming — Google
                  en Microsoft (marketingcookies). Met deze partijen zijn afspraken gemaakt over de
                  bescherming van je gegevens. Verder verstrekken we gegevens alleen als de wet ons
                  daartoe verplicht.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Hoe lang we gegevens bewaren</h2>
                <p>
                  We bewaren je gegevens niet langer dan nodig. Gegevens uit het contactformulier en de
                  brochure-aanvraag bewaren we zolang dat nodig is om je vraag af te handelen en de
                  relatie op te volgen, en daarna maximaal twee jaar, tenzij een wettelijke plicht een
                  langere termijn vraagt.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Jouw rechten</h2>
                <p>
                  Je hebt het recht om je gegevens in te zien, te laten corrigeren of verwijderen, de
                  verwerking te laten beperken, bezwaar te maken en je gegevens overgedragen te krijgen.
                  Gegeven toestemming (zoals voor cookies) kun je altijd intrekken. Mail daarvoor naar
                  info@puntuit.nl; we reageren binnen vier weken. Vind je dat we niet goed met je
                  gegevens omgaan, dan kun je een klacht indienen bij de Autoriteit Persoonsgegevens.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Beveiliging en wijzigingen</h2>
                <p>
                  We nemen passende technische en organisatorische maatregelen om je gegevens te
                  beschermen, zoals versleutelde verbindingen (https). Deze privacyverklaring kan
                  wijzigen; de actuele versie staat altijd op deze pagina.
                </p>
              </div>

            </article>
          </div>
        </section>
      </div>
    </>
  );
}
